import "./style.css";

const STORAGE_KEY = "audiobook.progress.v1";
const SPEED_KEY = "audiobook.speed";
const SAVE_INTERVAL_MS = 1500;
const SPEEDS = [0.75, 1, 1.25, 1.5, 1.75, 2];

const icons = {
  play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>',
  pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>',
  previous: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 5h2v14H6zm3 7 9 7V5z"/></svg>',
  next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="m6 5 9 7-9 7zm10 0h2v14h-2z"/></svg>',
  back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M11 6V3L6 7l5 4V8a5 5 0 1 1-4.6 7H4.3A7 7 0 1 0 11 6z"/><text x="9" y="16" font-size="6" fill="#18140f">15</text></svg>',
  forward: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13 6V3l5 4-5 4V8a5 5 0 1 0 4.6 7h2.1A7 7 0 1 1 13 6z"/><text x="9" y="16" font-size="6" fill="#18140f">15</text></svg>',
  chevron: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" d="m8 10 4 4 4-4"/></svg>',
};

document.querySelector("#app").innerHTML = `
  <div class="mx-auto min-h-screen max-w-[1600px] pb-44 lg:pb-36">
    <header class="px-4 pb-5 pt-6 sm:px-6 lg:px-8 lg:pb-7 lg:pt-8">
      <div class="flex items-center justify-between gap-4">
        <div>
          <p class="mb-1 text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-amber-400/80">Thư viện cá nhân</p>
          <h1 class="font-display text-2xl font-semibold tracking-tight text-stone-50 sm:text-3xl">Sách nói · Karaoke</h1>
        </div>
        <div id="saveBadge" class="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-stone-400">Tự động lưu</div>
      </div>
    </header>

    <main class="grid gap-4 px-3 sm:px-5 lg:grid-cols-[21rem_minmax(0,1fr)] lg:gap-6 lg:px-8">
      <aside class="glass-panel overflow-hidden rounded-3xl lg:sticky lg:top-5 lg:h-[calc(100vh-10.5rem)]">
        <div class="flex gap-4 border-b border-white/8 p-4">
          <img id="cover" class="h-24 w-16 rounded-lg object-cover shadow-xl shadow-black/40" alt="Bìa sách" />
          <div class="min-w-0 self-center">
            <p id="bookAuthor" class="text-xs uppercase tracking-[0.14em] text-amber-300/75"></p>
            <h2 id="bookTitle" class="mt-1 font-display text-xl font-semibold leading-tight text-stone-50"></h2>
            <p id="bookMeta" class="mt-2 text-xs text-stone-400"></p>
          </div>
        </div>
        <nav id="library" class="chapter-scroll max-h-[52vh] overflow-y-auto p-2 lg:max-h-[calc(100%-8.5rem)]" aria-label="Danh sách tập và chương"></nav>
      </aside>

      <section class="glass-panel min-w-0 overflow-hidden rounded-3xl">
        <div class="border-b border-white/8 px-5 py-5 sm:px-8 sm:py-7">
          <div class="flex flex-wrap items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-amber-300/75">
            <span id="volumeLabel"></span><span class="text-stone-600">/</span><span id="chapterPosition"></span>
          </div>
          <h2 id="chapterTitle" class="mt-2 max-w-4xl font-display text-2xl font-semibold leading-tight text-stone-50 sm:text-4xl"></h2>
          <p id="chapterSubtitle" class="mt-2 max-w-3xl text-sm leading-relaxed text-stone-400 sm:text-base"></p>
          <div class="mt-4 flex flex-wrap gap-2" role="group" aria-label="Cách hiển thị nội dung">
            <button id="readMode" class="reading-mode" aria-pressed="true" aria-controls="transcript">Đọc sách</button>
            <button id="followMode" class="reading-mode" aria-pressed="false" aria-controls="transcript">Theo lời đọc</button>
          </div>
        </div>
        <div
          id="transcript"
          class="transcript chapter-scroll max-h-[62vh] min-h-[38vh] overflow-y-auto px-5 py-7 sm:px-8 sm:py-10 lg:max-h-[calc(100vh-19rem)]"
          aria-live="polite"
        >
          <p class="text-stone-500">Đang tải nội dung…</p>
        </div>
      </section>
    </main>
  </div>

  <div class="fixed inset-x-0 bottom-0 z-50 p-2 sm:p-4">
    <section class="glass-panel mx-auto max-w-5xl rounded-[1.6rem] px-3 py-3 shadow-2xl shadow-black/50 sm:px-5" aria-label="Trình phát sách nói">
      <div class="flex items-center gap-3">
        <button id="previousButton" class="grid size-10 shrink-0 place-items-center rounded-full text-stone-300 hover:bg-white/8 disabled:cursor-not-allowed disabled:opacity-30" aria-label="Chương trước"><span class="size-5">${icons.previous}</span></button>
        <button id="backButton" class="hidden size-10 shrink-0 place-items-center rounded-full text-stone-300 hover:bg-white/8 sm:grid" aria-label="Lùi 15 giây"><span class="size-6">${icons.back}</span></button>
        <button id="playButton" class="grid size-12 shrink-0 place-items-center rounded-full bg-amber-400 text-stone-950 shadow-lg shadow-amber-500/20 transition hover:scale-105 hover:bg-amber-300" aria-label="Phát"><span class="size-6">${icons.play}</span></button>
        <button id="forwardButton" class="hidden size-10 shrink-0 place-items-center rounded-full text-stone-300 hover:bg-white/8 sm:grid" aria-label="Tiến 15 giây"><span class="size-6">${icons.forward}</span></button>
        <button id="nextButton" class="grid size-10 shrink-0 place-items-center rounded-full text-stone-300 hover:bg-white/8 disabled:cursor-not-allowed disabled:opacity-30" aria-label="Chương tiếp theo"><span class="size-5">${icons.next}</span></button>
        <button id="speedButton" class="hidden shrink-0 rounded-full border border-white/10 px-2.5 py-1 font-mono text-[0.7rem] font-semibold tabular-nums text-stone-300 hover:bg-white/8 sm:block" aria-label="Tốc độ phát">1x</button>

        <div class="min-w-0 flex-1">
          <div class="mb-1 flex items-center justify-between gap-3">
            <p id="nowPlaying" class="truncate text-xs font-medium text-stone-200 sm:text-sm"></p>
            <p class="shrink-0 font-mono text-[0.68rem] tabular-nums text-stone-400 sm:text-xs"><span id="currentTime">00:00</span> / <span id="duration">00:00</span></p>
          </div>
          <input id="progress" class="range block" type="range" min="0" max="0" step="0.05" value="0" aria-label="Tiến độ phát" />
        </div>
      </div>
      <p id="playerMessage" class="mt-1 hidden text-center text-xs text-rose-300" role="status"></p>
    </section>
  </div>

  <audio id="audio" preload="metadata" playsinline></audio>
`;

const elements = {
  audio: document.querySelector("#audio"),
  library: document.querySelector("#library"),
  cover: document.querySelector("#cover"),
  bookTitle: document.querySelector("#bookTitle"),
  bookAuthor: document.querySelector("#bookAuthor"),
  bookMeta: document.querySelector("#bookMeta"),
  volumeLabel: document.querySelector("#volumeLabel"),
  chapterPosition: document.querySelector("#chapterPosition"),
  chapterTitle: document.querySelector("#chapterTitle"),
  chapterSubtitle: document.querySelector("#chapterSubtitle"),
  transcript: document.querySelector("#transcript"),
  readMode: document.querySelector("#readMode"),
  followMode: document.querySelector("#followMode"),
  playButton: document.querySelector("#playButton"),
  previousButton: document.querySelector("#previousButton"),
  nextButton: document.querySelector("#nextButton"),
  backButton: document.querySelector("#backButton"),
  forwardButton: document.querySelector("#forwardButton"),
  progress: document.querySelector("#progress"),
  currentTime: document.querySelector("#currentTime"),
  duration: document.querySelector("#duration"),
  nowPlaying: document.querySelector("#nowPlaying"),
  playerMessage: document.querySelector("#playerMessage"),
  saveBadge: document.querySelector("#saveBadge"),
  speedButton: document.querySelector("#speedButton"),
};

const state = {
  catalog: null,
  book: null,
  chapters: [],
  currentIndex: 0,
  cues: [],
  cueElements: [],
  chapterText: null,
  readingMode: "read",
  activeCue: -1,
  pendingSeek: 0,
  fetchController: null,
  rafId: null,
  lastSaveAt: 0,
  userScrollUntil: 0,
};

function formatTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return "00:00";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return hours > 0
    ? `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`
    : `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

function parseTimestamp(value) {
  const parts = value.replace(",", ".").split(":");
  if (parts.length === 3) return Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2]);
  if (parts.length === 2) return Number(parts[0]) * 60 + Number(parts[1]);
  return Number.NaN;
}

function decodeCueText(value) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = value.replace(/<[^>]+>/g, "");
  return textarea.value.trim();
}

export function parseWebVtt(source) {
  const normalized = source.replace(/^\uFEFF/, "").replace(/\r\n?/g, "\n");
  const blocks = normalized.split(/\n{2,}/);
  const cues = [];

  for (const block of blocks) {
    const lines = block.split("\n").map((line) => line.trim()).filter(Boolean);
    if (!lines.length || /^(WEBVTT|NOTE|STYLE|REGION)/.test(lines[0])) continue;
    const timingIndex = lines.findIndex((line) => line.includes("-->"));
    if (timingIndex < 0) continue;
    const timing = lines[timingIndex].match(
      /((?:\d{2}:)?\d{2}:\d{2}[.,]\d{3})\s*-->\s*((?:\d{2}:)?\d{2}:\d{2}[.,]\d{3})/,
    );
    if (!timing) continue;
    const text = decodeCueText(lines.slice(timingIndex + 1).join(" "));
    const start = parseTimestamp(timing[1]);
    const end = parseTimestamp(timing[2]);
    if (text && Number.isFinite(start) && Number.isFinite(end) && end >= start) {
      cues.push({ start, end, text });
    }
  }
  return cues.sort((a, b) => a.start - b.start);
}

function groupCues(cues) {
  const groups = [];
  let group = [];
  cues.forEach((cue, index) => {
    group.push({ ...cue, index });
    const endsSentence = /[.!?…][”’"')\]}»]*$/.test(cue.text);
    if (endsSentence || group.length >= 28) {
      groups.push(group);
      group = [];
    }
  });
  if (group.length) groups.push(group);
  return groups;
}

function renderKaraoke(cues) {
  elements.transcript.replaceChildren();
  state.cueElements = new Array(cues.length);
  const fragment = document.createDocumentFragment();

  for (const group of groupCues(cues)) {
    const paragraph = document.createElement("p");
    paragraph.className = "karaoke-line";
    for (const cue of group) {
      const span = document.createElement("span");
      span.className = "karaoke-word";
      span.textContent = cue.text;
      span.dataset.cueIndex = String(cue.index);
      paragraph.append(span, document.createTextNode(" "));
      state.cueElements[cue.index] = span;
    }
    fragment.append(paragraph);
  }
  elements.transcript.append(fragment);
}

function renderPlainText(text) {
  elements.transcript.replaceChildren();
  const fragment = document.createDocumentFragment();
  const paragraphs = text.replace(/^\uFEFF/, "").split(/\r?\n\s*\r?\n/).map((item) => item.trim()).filter(Boolean);
  for (const value of paragraphs) {
    const paragraph = document.createElement("p");
    paragraph.className = "plain-paragraph";
    paragraph.textContent = value.replace(/\s*\r?\n\s*/g, " ");
    fragment.append(paragraph);
  }
  elements.transcript.append(fragment);
}

function renderTranscript() {
  state.cueElements = [];
  state.activeCue = -1;
  elements.readMode.disabled = state.chapterText === null;
  elements.followMode.disabled = !state.cues.length;
  const follow = state.cues.length > 0 && (state.readingMode === "follow" || state.chapterText === null);
  elements.readMode.setAttribute("aria-pressed", String(!follow && state.chapterText !== null));
  elements.followMode.setAttribute("aria-pressed", String(follow));
  if (follow) {
    renderKaraoke(state.cues);
    updateKaraoke();
  } else if (state.chapterText !== null) {
    renderPlainText(state.chapterText);
  } else {
    elements.transcript.innerHTML = '<p class="text-rose-300">Không tải được nội dung chương.</p>';
  }
}

function findCueIndex(time) {
  let low = 0;
  let high = state.cues.length - 1;
  let result = -1;
  while (low <= high) {
    const middle = (low + high) >> 1;
    if (state.cues[middle].start <= time) {
      result = middle;
      low = middle + 1;
    } else {
      high = middle - 1;
    }
  }
  if (result < 0) return -1;
  return time <= state.cues[result].end + 0.08 ? result : -1;
}

function updateKaraoke() {
  if (!state.cues.length || !state.cueElements.length) return;
  const nextIndex = findCueIndex(elements.audio.currentTime);
  if (nextIndex === state.activeCue) return;

  const previous = state.cueElements[state.activeCue];
  previous?.classList.remove("is-active");
  previous?.parentElement?.classList.remove("is-active");

  state.activeCue = nextIndex;
  const active = state.cueElements[nextIndex];
  active?.classList.add("is-active");
  active?.parentElement?.classList.add("is-active");

  if (active && Date.now() > state.userScrollUntil) {
    const scroller = elements.transcript.getBoundingClientRect();
    const rect = active.getBoundingClientRect();
    const outsideReadingBand = rect.top < scroller.top + scroller.height * 0.22 || rect.bottom > scroller.top + scroller.height * 0.78;
    if (outsideReadingBand) active.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

function animationLoop() {
  updateKaraoke();
  if (!elements.audio.paused && !elements.audio.ended) {
    state.rafId = requestAnimationFrame(animationLoop);
  }
}

function setPlayingUi(isPlaying) {
  elements.playButton.querySelector("span").innerHTML = isPlaying ? icons.pause : icons.play;
  elements.playButton.setAttribute("aria-label", isPlaying ? "Tạm dừng" : "Phát");
}

function setMessage(message = "") {
  elements.playerMessage.textContent = message;
  elements.playerMessage.classList.toggle("hidden", !message);
}

function currentChapter() {
  return state.chapters[state.currentIndex];
}

function seekTo(time) {
  const duration = elements.audio.duration;
  const upperBound = Number.isFinite(duration) ? duration : Number.POSITIVE_INFINITY;
  elements.audio.currentTime = Math.max(0, Math.min(Number(time) || 0, upperBound));
  updateTimeline();
  saveProgress(true);
}

function updateMediaMetadata(chapter) {
  document.title = `${chapter.title}${chapter.subtitle ? ` · ${chapter.subtitle}` : ""} — ${state.book.title}`;
  if (!("mediaSession" in navigator) || typeof MediaMetadata !== "function") return;
  const coverUrl = new URL(state.book.cover, window.location.href).href;
  navigator.mediaSession.metadata = new MediaMetadata({
    title: chapter.subtitle || chapter.title,
    artist: state.book.authors.join(" · "),
    album: `${state.book.title} · ${chapter.volumeTitle}`,
    artwork: [{ src: coverUrl, type: "image/jpeg" }],
  });
}

function setMediaPlaybackState(value) {
  if (!("mediaSession" in navigator)) return;
  try {
    navigator.mediaSession.playbackState = value;
  } catch {
    // Some WebKit versions expose the object but not a writable playbackState.
  }
}

function updateMediaPosition() {
  if (!("mediaSession" in navigator) || typeof navigator.mediaSession.setPositionState !== "function") return;
  const duration = elements.audio.duration;
  const position = elements.audio.currentTime;
  if (!Number.isFinite(duration) || duration <= 0 || !Number.isFinite(position)) return;
  try {
    navigator.mediaSession.setPositionState({
      duration,
      playbackRate: elements.audio.playbackRate,
      position: Math.min(Math.max(position, 0), duration),
    });
  } catch {
    // Older Safari/Chromium versions expose Media Session only partially.
  }
}

function registerMediaSession() {
  if (!("mediaSession" in navigator)) return;
  const handlers = {
    play: () => elements.audio.play(),
    pause: () => elements.audio.pause(),
    seekbackward: (details) => seekTo(elements.audio.currentTime - (details.seekOffset || 15)),
    seekforward: (details) => seekTo(elements.audio.currentTime + (details.seekOffset || 15)),
    seekto: (details) => {
      if (typeof details.seekTime !== "number") return;
      if (details.fastSeek && "fastSeek" in elements.audio) {
        elements.audio.fastSeek(details.seekTime);
        updateTimeline();
        saveProgress(true);
      } else seekTo(details.seekTime);
    },
    previoustrack: () => loadChapter(state.currentIndex - 1, { autoplay: true }),
    nexttrack: () => loadChapter(state.currentIndex + 1, { autoplay: true }),
  };
  for (const [action, handler] of Object.entries(handlers)) {
    try {
      navigator.mediaSession.setActionHandler(action, handler);
    } catch {
      // Unsupported actions differ between Windows, Android, and iOS versions.
    }
  }
}

function saveProgress(force = false) {
  const now = Date.now();
  if (!force && now - state.lastSaveAt < SAVE_INTERVAL_MS) return;
  const chapter = currentChapter();
  updateMediaMetadata(chapter);
  if (!chapter || !state.book) return;
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      bookId: state.book.id,
      chapterId: chapter.id,
      currentTime: Number(elements.audio.currentTime.toFixed(2)) || 0,
      updatedAt: new Date().toISOString(),
    }),
  );
  state.lastSaveAt = now;
  elements.saveBadge.textContent = "Đã lưu tiến độ";
}

function readProgress() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

function flattenChapters(book) {
  return book.volumes.flatMap((volume) =>
    volume.chapters.map((chapter) => ({ ...chapter, volumeId: volume.id, volumeTitle: volume.title })),
  );
}

function renderLibrary() {
  elements.library.replaceChildren();
  let flatIndex = 0;
  for (const volume of state.book.volumes) {
    const details = document.createElement("details");
    details.className = "group rounded-2xl open:bg-white/[0.025]";
    const containsCurrent = volume.chapters.some((chapter) => chapter.id === currentChapter()?.id);
    details.open = containsCurrent;

    const summary = document.createElement("summary");
    summary.className = "flex cursor-pointer list-none items-center justify-between gap-3 rounded-xl px-3 py-3 text-sm font-semibold text-stone-200 hover:bg-white/5";
    const title = document.createElement("span");
    title.textContent = volume.title;
    const chevron = document.createElement("span");
    chevron.className = "size-4 text-stone-500 transition group-open:rotate-180";
    chevron.innerHTML = icons.chevron;
    summary.append(title, chevron);
    details.append(summary);

    const list = document.createElement("ol");
    list.className = "space-y-0.5 pb-2";
    for (const chapter of volume.chapters) {
      const chapterIndex = flatIndex++;
      const item = document.createElement("li");
      const button = document.createElement("button");
      const active = chapterIndex === state.currentIndex;
      button.type = "button";
      button.className = active
        ? "w-full rounded-xl bg-amber-400/12 px-3 py-2.5 text-left text-sm text-amber-200 ring-1 ring-inset ring-amber-400/20"
        : "w-full rounded-xl px-3 py-2.5 text-left text-sm text-stone-400 hover:bg-white/5 hover:text-stone-200";
      button.dataset.chapterIndex = String(chapterIndex);
      button.setAttribute("aria-current", active ? "true" : "false");
      const orderLabel = document.createElement("span");
      orderLabel.className = "mr-2 font-mono text-[0.65rem] text-stone-600";
      orderLabel.textContent = String(chapter.order).padStart(2, "0");
      const chapterLabel = document.createElement("span");
      chapterLabel.textContent = chapter.title;
      button.append(orderLabel, chapterLabel);
      if (chapter.subtitle) {
        const subtitle = document.createElement("span");
        subtitle.className = "mt-1 block pl-7 text-xs leading-snug text-stone-500";
        subtitle.textContent = chapter.subtitle;
        button.append(subtitle);
      }
      item.append(button);
      list.append(item);
    }
    details.append(list);
    elements.library.append(details);
  }
}

async function fetchText(url, signal) {
  const response = await fetch(url, { signal });
  if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
  return response.text();
}

async function loadChapter(index, options = {}) {
  if (index < 0 || index >= state.chapters.length) return;
  const { autoplay = false, resumeTime = 0 } = options;
  state.fetchController?.abort();
  state.fetchController = new AbortController();
  const { signal } = state.fetchController;
  state.currentIndex = index;
  state.cues = [];
  state.cueElements = [];
  state.chapterText = null;
  elements.readMode.disabled = true;
  elements.followMode.disabled = true;
  state.activeCue = -1;
  state.pendingSeek = Math.max(0, Number(resumeTime) || 0);
  cancelAnimationFrame(state.rafId);

  const chapter = currentChapter();
  elements.volumeLabel.textContent = chapter.volumeTitle;
  elements.chapterPosition.textContent = `${state.currentIndex + 1} / ${state.chapters.length}`;
  elements.chapterTitle.textContent = chapter.title;
  elements.chapterSubtitle.textContent = chapter.subtitle || "";
  elements.nowPlaying.textContent = `${chapter.title}${chapter.subtitle ? ` · ${chapter.subtitle}` : ""}`;
  elements.transcript.innerHTML = '<p class="text-stone-500">Đang tải nội dung…</p>';
  elements.previousButton.disabled = index === 0;
  elements.nextButton.disabled = index === state.chapters.length - 1;
  elements.progress.value = "0";
  elements.progress.style.setProperty("--progress", "0%");
  elements.currentTime.textContent = "00:00";
  elements.duration.textContent = "00:00";
  setMessage();
  renderLibrary();

  elements.audio.src = chapter.audio;
  elements.audio.load();

  const [vttResult, textResult] = await Promise.allSettled([
    fetchText(chapter.vtt, signal),
    fetchText(chapter.text, signal),
  ]);
  if (signal.aborted) return;

  if (vttResult.status === "fulfilled") {
    state.cues = parseWebVtt(vttResult.value);
  }
  state.chapterText = textResult.status === "fulfilled" ? textResult.value : null;
  renderTranscript();
  elements.transcript.scrollTop = 0;
  if (!state.cues.length && state.chapterText !== null) {
    setMessage("Chưa có phụ đề VTT; đang hiển thị nội dung TXT.");
  }

  if (!resumeTime) saveProgress(true);
  if (autoplay) {
    const continuePlayback = () => elements.audio.play().catch(() => setMessage("Nhấn Phát để tiếp tục."));
    if (elements.audio.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) continuePlayback();
    else elements.audio.addEventListener("canplay", continuePlayback, { once: true });
  }
}

async function togglePlayback() {
  if (!elements.audio.src) return;
  if (elements.audio.paused) {
    try {
      await elements.audio.play();
      setMessage();
    } catch {
      setMessage("Không phát được audio. Kiểm tra file MP3 hoặc tắt bắt link IDM cho website này.");
    }
  } else {
    elements.audio.pause();
  }
}

function updateTimeline() {
  const current = elements.audio.currentTime || 0;
  const duration = elements.audio.duration || 0;
  elements.currentTime.textContent = formatTime(current);
  elements.duration.textContent = formatTime(duration);
  elements.progress.max = String(duration || 0);
  elements.progress.value = String(current);
  const percent = duration ? (current / duration) * 100 : 0;
  elements.progress.style.setProperty("--progress", `${percent}%`);
  updateKaraoke();
  updateMediaPosition();
  saveProgress();
}

function formatSpeed(rate) {
  return rate % 1 === 0 ? `${rate}x` : `${rate}x`;
}

function loadSpeed() {
  try {
    const saved = Number(localStorage.getItem(SPEED_KEY));
    if (SPEEDS.includes(saved)) return saved;
  } catch {}
  return 1;
}

function setSpeed(rate) {
  elements.audio.playbackRate = rate;
  elements.speedButton.textContent = formatSpeed(rate);
  try { localStorage.setItem(SPEED_KEY, String(rate)); } catch {}
}

function cycleSpeed() {
  const current = elements.audio.playbackRate;
  const idx = SPEEDS.indexOf(current);
  setSpeed(SPEEDS[(idx + 1) % SPEEDS.length]);
}

function bindEvents() {
  for (const [button, mode] of [[elements.readMode, "read"], [elements.followMode, "follow"]]) {
    button.addEventListener("click", () => {
      state.readingMode = mode;
      renderTranscript();
    });
  }
  elements.library.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-chapter-index]");
    if (button) loadChapter(Number(button.dataset.chapterIndex));
  });
  elements.playButton.addEventListener("click", togglePlayback);
  elements.previousButton.addEventListener("click", () => loadChapter(state.currentIndex - 1, { autoplay: !elements.audio.paused }));
  elements.nextButton.addEventListener("click", () => loadChapter(state.currentIndex + 1, { autoplay: !elements.audio.paused }));
  elements.backButton.addEventListener("click", () => seekTo(elements.audio.currentTime - 15));
  elements.forwardButton.addEventListener("click", () => seekTo(elements.audio.currentTime + 15));
  elements.speedButton.addEventListener("click", cycleSpeed);
  elements.progress.addEventListener("input", () => seekTo(elements.progress.value));

  elements.audio.addEventListener("loadedmetadata", () => {
    if (state.pendingSeek > 0 && Number.isFinite(elements.audio.duration)) {
      elements.audio.currentTime = Math.min(state.pendingSeek, Math.max(0, elements.audio.duration - 0.25));
      state.pendingSeek = 0;
    }
    updateTimeline();
  });
  elements.audio.addEventListener("timeupdate", updateTimeline);
  elements.audio.addEventListener("play", () => {
    setPlayingUi(true);
    setMediaPlaybackState("playing");
    cancelAnimationFrame(state.rafId);
    state.rafId = requestAnimationFrame(animationLoop);
  });
  elements.audio.addEventListener("pause", () => {
    setPlayingUi(false);
    setMediaPlaybackState("paused");
    saveProgress(true);
  });
  elements.audio.addEventListener("ended", () => {
    saveProgress(true);
    if (state.currentIndex < state.chapters.length - 1) loadChapter(state.currentIndex + 1, { autoplay: true });
    else setMessage("Bạn đã nghe hết cuốn sách.");
  });
  elements.audio.addEventListener("error", () => {
    setMessage("Không tải được MP3. Nếu file đã tồn tại, hãy thêm website này vào danh sách loại trừ của IDM.");
  });

  ["wheel", "touchstart", "pointerdown"].forEach((type) => {
    elements.transcript.addEventListener(type, () => { state.userScrollUntil = Date.now() + 5000; }, { passive: true });
  });
  window.addEventListener("beforeunload", () => saveProgress(true));
  document.addEventListener("keydown", (event) => {
    if (["INPUT", "BUTTON", "TEXTAREA", "SELECT"].includes(event.target.tagName)) return;
    if (event.code === "Space") { event.preventDefault(); togglePlayback(); }
    if (event.code === "ArrowLeft") {
      seekTo(elements.audio.currentTime - 15);
    }
    if (event.code === "ArrowRight") {
      seekTo(elements.audio.currentTime + 15);
    }
  });
}

async function init() {
  bindEvents();
  registerMediaSession();
  setSpeed(loadSpeed());
  try {
    const response = await fetch("/data.json");
    if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
    state.catalog = await response.json();
    state.book = state.catalog.books[0];
    state.chapters = flattenChapters(state.book);
    elements.cover.src = state.book.cover;
    elements.bookTitle.textContent = state.book.title;
    elements.bookAuthor.textContent = state.book.authors.join(" · ");
    elements.bookMeta.textContent = `${state.book.volumes.length} tập · ${state.chapters.length} mục`;

    const saved = readProgress();
    const savedIndex = saved?.bookId === state.book.id
      ? state.chapters.findIndex((chapter) => chapter.id === saved.chapterId)
      : -1;
    await loadChapter(savedIndex >= 0 ? savedIndex : 0, { resumeTime: savedIndex >= 0 ? saved.currentTime : 0 });
  } catch (error) {
    console.error(error);
    elements.transcript.innerHTML = '<p class="text-rose-300">Không tải được data.json. Hãy chạy ứng dụng qua Vite thay vì mở file HTML trực tiếp.</p>';
    setMessage("Không khởi tạo được thư viện.");
  }
}

init();
